import { GridFilterModel } from '@mui/x-data-grid-premium'
import CustomFiltersModal from 'components/DataGrid/components/CustomFiltersModal'
import CustomStatusFilter from 'components/DataGrid/createColumns/CustomStatusFilter'
import CustomFiltersMenu from 'components/ui/custom-filters-menu-button'
import React, { useMemo, useState } from 'react'
import { DEPARTMENT_OPTIONS, TA_TYPE_OPTIONS } from './defaultModels'

const serviceLineFilterOptions = [
  { label: 'SEO', value: 'seo', color: '#4caf50' },
  { label: 'PPC', value: 'ppc', color: '#ff9800' },
  { label: 'Web', value: 'web', color: '#2196f3' },
  { label: 'Social', value: 'social', color: '#e91e63' },
  { label: 'Creative', value: 'creative', color: '#9c27b0' },
  { label: 'Email', value: 'emm', color: '#00bcd4' },
  { label: 'Analytics', value: 'ana', color: '#607d8b' },
  { label: 'UX', value: 'ux', color: '#795548' },
  { label: 'Integration', value: 'int', color: '#3f51b5' },
]

const categoryFilterOptions = [
  { label: 'Web Development', value: 'Web Development', color: '#2196f3' },
  { label: 'UX/Design', value: 'UX/Design', color: '#795548' },
  { label: 'SEO', value: 'SEO', color: '#4caf50' },
  { label: 'Paid Media', value: 'Paid Media', color: '#ff9800' },
  { label: 'Analytics', value: 'Analytics', color: '#607d8b' },
  { label: 'Integration', value: 'Integration', color: '#3f51b5' },
  { label: 'Email Marketing', value: 'Email Marketing', color: '#00bcd4' },
  { label: 'Social Media', value: 'Social Media', color: '#e91e63' },
  { label: 'Creative', value: 'Creative', color: '#9c27b0' },
]

const statusFilterOptions = [
  { label: 'Active', value: 'Active', color: 'rgb(75, 185, 114)' },
  { label: 'Deprecated', value: 'Deprecated', color: 'rgb(238, 111, 141)' },
]

const deliveryRoleFilterOptions = [
  { label: 'Web Developer', value: 'Web Developer', color: '#2196f3' },
  { label: 'SEO Specialist', value: 'SEO Specialist', color: '#4caf50' },
  { label: 'Paid Media Specialist', value: 'Paid Media Specialist', color: '#ff9800' },
  { label: 'Creative Specialist', value: 'Creative Specialist', color: '#9c27b0' },
  { label: 'Analytics Specialist', value: 'Analytics Specialist', color: '#607d8b' },
  { label: 'UX Strategist', value: 'UX Strategist', color: '#795548' },
  { label: 'Email Marketing Specialist', value: 'Email Marketing Specialist', color: '#00bcd4' },
  { label: 'Reporting Specialist', value: 'Reporting Specialist', color: '#607d8b' },
  { label: 'Project Manager', value: 'Project Manager', color: '#3f51b5' },
  { label: 'Project Coordinator', value: 'Project Coordinator', color: '#3f51b5' },
]

const ServiceMenuFilters = ({
  filterModel,
  onSetFilter,
  isOpen,
  anchorEl,
  onOpenFilters,
  onClose,
}: {
  filterModel: GridFilterModel
  onSetFilter: (fieldName: string, selectedValues: string[]) => void
  isOpen: boolean
  anchorEl: HTMLElement | null
  onOpenFilters: (event: React.MouseEvent) => void
  onClose: () => void
}) => {
  const [filterServiceLine, setFilterServiceLine] = useState<string>('')
  const [filterCategory, setFilterCategory] = useState<string>('')
  const [filterStatus, setFilterStatus] = useState<string>('')
  const [filterDeliveryRole, setFilterDeliveryRole] = useState<string>('')
  const [filterTaType, setFilterTaType] = useState<string>('')
  const [filterDept, setFilterDept] = useState<string>('')

  const memoizedServiceLineOptions = useMemo(() => serviceLineFilterOptions, [])
  const memoizedCategoryOptions = useMemo(() => categoryFilterOptions, [])
  const memoizedStatusOptions = useMemo(() => statusFilterOptions, [])
  const memoizedDeliveryRoleOptions = useMemo(() => deliveryRoleFilterOptions, [])
  const memoizedTaTypeOptions = useMemo(() => TA_TYPE_OPTIONS, [])
  const memoizedDepartmentOptions = useMemo(() => DEPARTMENT_OPTIONS, [])

  return (
    <>
      <CustomFiltersMenu
        onOpenCustomFilters={onOpenFilters}
        count={filterModel?.items?.length ?? 0}
        badgeColor={'icon.service_menu'}
      />
      <CustomFiltersModal isOpen={isOpen} anchorEl={anchorEl} handleCloseCustomFilters={onClose}>
        <CustomStatusFilter
          context={'service_line'}
          options={memoizedServiceLineOptions}
          setterFn={setFilterServiceLine}
          filterModel={filterModel}
          value={filterServiceLine}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'category_name'}
          options={memoizedCategoryOptions}
          setterFn={setFilterCategory}
          filterModel={filterModel}
          value={filterCategory}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'status'}
          options={memoizedStatusOptions}
          setterFn={setFilterStatus}
          filterModel={filterModel}
          value={filterStatus}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'delivery_role'}
          options={memoizedDeliveryRoleOptions}
          setterFn={setFilterDeliveryRole}
          filterModel={filterModel}
          value={filterDeliveryRole}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'ta_type'}
          options={memoizedTaTypeOptions}
          setterFn={setFilterTaType}
          filterModel={filterModel}
          value={filterTaType}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'subcategory'}
          options={memoizedDepartmentOptions}
          setterFn={setFilterDept}
          filterModel={filterModel}
          value={filterDept}
          onChange={onSetFilter}
        />
      </CustomFiltersModal>
    </>
  )
}

export default ServiceMenuFilters
